"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PRECISE_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var BASIC_PATTERN = /^\S+@\S+\.\S+$/;
function emailValidationRule(_a) {
    var messages = _a.messages, schema = _a.schema;
    var src = [];
    var pattern = schema.mode == 'precise' ? PRECISE_PATTERN : BASIC_PATTERN;
    var sanitized = false;
    src.push("\n\t\tif (typeof value !== \"string\") {\n\t\t\t" + this.makeError({ actual: 'value', messages: messages, type: 'string' }) + "\n\t\t\treturn value;\n\t\t}\n\t");
    if (!schema.empty) {
        src.push("\n\t\t\tif (value.length === 0) {\n\t\t\t\t" + this.makeError({ actual: 'value', messages: messages, type: 'emailEmpty' }) + "\n        return value;\n\t\t\t}\n\t\t");
    }
    else {
        src.push("\n\t\t\tif (value.length === 0) return value;\n\t\t");
    }
    if (schema.normalize) {
        sanitized = true;
        src.push("\n\t\t\tvalue = value.trim().toLowerCase();\n\t\t");
    }
    if (schema.min != null) {
        src.push("\n\t\t\tif (value.length < " + schema.min + ") {\n\t\t\t\t" + this.makeError({ actual: 'value.length', expected: schema.min, messages: messages, type: 'emailMin' }) + "\n\t\t\t}\n\t\t");
    }
    if (schema.max != null) {
        src.push("\n\t\t\tif (value.length > " + schema.max + ") {\n\t\t\t\t" + this.makeError({ actual: 'value.length', expected: schema.max, messages: messages, type: 'emailMax' }) + "\n\t\t\t}\n\t\t");
    }
    src.push("\n\t\tif (!" + pattern.toString() + ".test(value)) {\n\t\t\t" + this.makeError({ actual: 'value', messages: messages, type: 'email' }) + "\n\t\t}\n\t\treturn value;\n\t");
    return {
        sanitized: sanitized,
        source: src.join('\n'),
    };
}
exports.default = emailValidationRule;
//# sourceMappingURL=emailValidationRule.js.map